
        import { createElement } from 'react';
        import { render } from 'react-dom';
        import 'wix/scripts/dashboard-asset/68e02dc2-575d-47b8-a838-b0f92c8459e6.js';

        async function main() {
          const getComponent = await window['__module_federation__containers']['bd59b79d-a12b-406d-914a-b85843e83362'].get('68e02dc2-575d-47b8-a838-b0f92c8459e6');
          render(createElement(getComponent().default), document.getElementById('root'));
        }

        main();
      